import Emitter from '../../emitter';
const LocalStoreService = require('../../api/store').default;
const CONSTANT = require('../../../constant').default;
const UserService = require('../../api/user.js').default;
console.log({ UserService });
let gLogin = false;
const Account = {
    id: 'account',
    getToken: () => {
        return new Promise((resolve) => {
            resolve(LocalStoreService.get(CONSTANT.USER_ACCESS_TOKEN_KEY));
        });
    },
    // 获取服务用的 Key
    getServiceKey: (name, option) => {
        return UserService.accesstoken(name, option);
    },
    // 获取登录后的用户信息
    getUserInfo: () => {
        return new Promise((resolve) => {
            resolve(LocalStoreService.get(CONSTANT.USER_INFO_KEY));
        });
    },
    // 登录事件
    onLogin: (handler) => {
        Emitter.on('Login', handler);
        return () => {
            Emitter.removeListener('Login', handler);
        };
    },
    onLogout: (handler) => {
        Emitter.on('Logout', handler);
        return () => {
            Emitter.removeListener('Logout', handler);
        };
    },
    isLogin() {
        return Promise.resolve(gLogin);
    }
};
Emitter.on('Login', () => { gLogin = true; });
Emitter.on('Logout', () => { gLogin = false; });
export { Account };
